export default __webpack_public_path__ + "static/media/xbc.df375823.svg";